"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[147],{

/***/ 6147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _growth_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3767);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5505);




function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var _templateObject$3;
var Style$2 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n\t.footer-links {\n\t\tdisplay: flex;\n\t\tjustify-content: space-between;\n\t\tpadding: 20px 0;\n\t}\n\n\ta {\n\t\ttext-decoration: none;\n\t\tcursor: pointer;\n\t}\n\n\t.footer-links ul {\n\t\twidth: 25%;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tlist-style: none;\n\t}\n\n\t.footer-links ul li {\n\t\tmargin-bottom: 5px;\n\t}\n\n\t.footer-links ul li:first-child {\n\t\ttext-transform: uppercase;\n\t\tfont-size: 12px;\n\t\tcolor: #000;\n\t\tmargin-bottom: 15px;\n\t\tfont-weight: 700;\n\t}\n\n\t.footer-links ul li a {\n\t\tdisplay: inline-flex;\n\t\tcolor: #777;\n\t\tfont-size: 12px;\n\t\tfont-family: Helvetica, sans-serif;\n\t}\n"])));

function FooterLinks(_ref) {
  var adobe = _ref.adobe;

  var sendEvent = function sendEvent(e) {
    var _e$target, _e$target2;

    adobe == null ? void 0 : adobe.track('ctaClick', {
      cta: {
        name: (_e$target = e.target) == null ? void 0 : _e$target.innerText,
        destination: (_e$target2 = e.target) == null ? void 0 : _e$target2.getAttribute('href'),
        componentName: 'footer',
        type: 'link'
      }
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style$2, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    role: "presentation",
    className: "footer-links",
    onClick: sendEvent
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "our products")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Domestic Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels-international/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "International Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Domestic Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/international-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "International Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/multicity-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Multi-City Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cfhotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Couple Friendly Hotels"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Nearby Getaways"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/bus/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Bus Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cab Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/airport-cabs/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Airport Cabs Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/cars/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Outstation Cabs Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Train Booking"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/gostays/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Go Stay"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.tripmoney.com/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Trip Money"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://advertising.goibibo.com/ad/solutions/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Goibibo Advertising Solutions")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "about us")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/aboutus/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "About Us"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/investors-overview/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Investor Relations"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/management/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Management"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/terms-of-services/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Terms of Services"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/user-agreement/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "User Agreement"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/info/privacy/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Privacy"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/careers/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Careers"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.youtube.com/user/goibibo",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "YouTube Channel"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://tech.goibibo.com/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Technology@Goibibo"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/customerHelp/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Customer Support"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.facebook.com/Goibibo/",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Facebook Page"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://twitter.com/goibibo",
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Twitter Handle")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "travel essentials")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/check-pnr-status/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "PNR Status"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/offers/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Offers"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/city-to-city-airlines/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Airline Routes"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/trains/check-train-running-status/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Train Running Status")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW3"
  }, "more links")), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/flights/cheap-flights/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cheap Flights"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/hotels/hotels-near-me/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Hotels Near Me"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/trips/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "My Bookings"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/mysupport/trips/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Cancellation"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/myaccount/settings/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "My Account"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.goibibo.com/myaccount/gocash/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Wallet"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://advertising.goibibo.com/ad/solutions/"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1"
  }, "Advertise with Us"))))));
}

var _templateObject$2;
var Styles = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n\t.footer-app-links {\n\t\tdisplay: flex;\n\t\tborder-bottom: solid 1px rgba(0, 0, 0, 0.2);\n\t\tpadding: 15px 0;\n\t\t-webkit-box-pack: justify;\n\t\tjustify-content: space-between;\n\t}\n\n\t.footer-app-links .follow-us {\n\t\tdisplay: flex;\n\t\t-webkit-flex-direction: column;\n\t\t-ms-flex-direction: column;\n\t\tflex-direction: column;\n\t\tfont-size: 14px;\n\t\tfont-weight: 700;\n\t}\n\n\t.footer-app-links .follow-us .social-icons {\n\t\tmargin-top: 10px;\n\t}\n\n\t.footer-app-links .follow-us .store-icons {\n\t\tmargin-top: 10px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t}\n\n\t.footer-app-links .payment-icons {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t.footer-sprite.facebookIcon {\n\t\tbackground-position: -213px -3px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.twitterIcon {\n\t\tbackground-position: -241px -3px;\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.youTubeIcon {\n\t\tbackground-position: -268px -3px;\n\t\twidth: 30px;\n\t\theight: 25px;\n\t}\n\n\t.footer-sprite.playStoreIcon {\n\t\tbackground-position: -0px -1px;\n\t\twidth: 107px;\n\t\theight: 38px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.appStoreIcon {\n\t\tbackground-position: -107px -1px;\n\t\twidth: 106px;\n\t\theight: 37px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.verifySign {\n\t\tbackground-position: -1px -41px;\n\t\twidth: 60px;\n\t\theight: 30px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.amricanIcon {\n\t\tbackground-position: -63px -41px;\n\t\twidth: 31px;\n\t\theight: 30px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.masterCardIcon {\n\t\tbackground-position: -97px -40px;\n\t\twidth: 49px;\n\t\theight: 33px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.visaIcon {\n\t\tbackground-position: -149px -40px;\n\t\twidth: 46px;\n\t\theight: 34px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.ruPayIcon {\n\t\tbackground-position: -5px -85px;\n\t\twidth: 84px;\n\t\theight: 23px;\n\t\tmargin-right: 10px;\n\t}\n\n\t.footer-sprite.iataIcon {\n\t\tbackground-position: -199px -43px;\n\t\twidth: 40px;\n\t\theight: 30px;\n\t}\n\n\t.footer-copyrights {\n\t\tborder-top: 1px solid #e6e6e6;\n\t\tpadding-top: 20px;\n\t\tpadding-bottom: 20px;\n\t\tcolor: #b3b3b3;\n\t\tfont-size: 11px;\n\t\tline-height: 1;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t}\n\n\t.footer-sprite.mmtLogo {\n\t\tbackground-position: -8px -120px;\n\t\twidth: 98px;\n\t\theight: 32px;\n\t\tmargin-right: 30px;\n\t\tposition: relative;\n\t\t-webkit-filter: grayscale(100%);\n\t\tfilter: grayscale(100%);\n\t\topacity: 0.5;\n\t}\n\n\t.footer-sprite.redBusLogo {\n\t\tbackground-position: -56px -166px;\n\t\twidth: 65px;\n\t\theight: 32px;\n\t\t-webkit-filter: grayscale(100%);\n\t\tfilter: grayscale(100%);\n\t\topacity: 0.6;\n\t}\n\n\t.footer-copyrights a:hover .redBusLogo,\n\t.footer-copyrights a:hover .mmtLogo {\n\t\t-webkit-filter: grayscale(0);\n\t\tfilter: grayscale(0);\n\t\topacity: 1;\n\t}\n"])));

var FooterAppLinks = function FooterAppLinks() {
  var year = new Date().getFullYear();
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Styles, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-app-links"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "follow-us"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "Follow Us"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "social-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://www.facebook.com/goibibo",
    title: "facebook",
    rel: "noreferrer",
    "aria-label": "Facebook"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite facebookIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://twitter.com/goibibo",
    title: "Twitter",
    rel: "noreferrer",
    "aria-label": "Twitter"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite twitterIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "http://www.youtube.com/user/goibibo",
    title: "youtube",
    rel: "noreferrer",
    "aria-label": "youtube"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite youTubeIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://plus.google.com/+goibibo/",
    className: "fl",
    title: "Google Plus",
    rel: "noreferrer",
    "aria-label": "Google Plus"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "hd_vs fr_gplus margin0"
  }, "\xA0")))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "follow-us"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("p", null, "Book Tickets faster. Download our mobile Apps"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "store-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://play.google.com/store/apps/details?id=com.goibibo&referrer=af_tranid%3DvxsPvRUmXy7VkUyrYCgpaQ%26pid%3Dmobile_site%26c%3Dm_header%26af_web_id%3Df6a83147-2300-4c5b-860d-d0a4e2e56160-c%26utm_source%3Dmobile_site%26utm_campaign%3Dm_header",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite playStoreIcon"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    target: "_blank",
    href: "https://apps.apple.com/in/app/goibibo-flight-bus-hotel-booking/id631927169",
    rel: "noreferrer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite appStoreIcon"
  })))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "payment-icons"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite verifySign"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite amricanIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite masterCardIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite visaIcon "
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite ruPayIcon"
  }, "\xA0"), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite iataIcon"
  }, "\xA0"))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-copyrights"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "brand-name"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.makemytrip.com/",
    target: "_black"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite mmtLogo"
  })), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
    href: "https://www.redbus.in/",
    target: "_black"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("span", {
    className: "footer-sprite redBusLogo"
  }))), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(_growth_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xv, {
    size: "SmallW1",
    as: "span",
    className: "sc-iqAclL fNjDal"
  }, "\xA9 ", year, " Makemytrip (India) Private Limited. All rights reserved")));
};

var _templateObject$1;
var Style$1 = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n\t.footer-dl {\n\t\tdisplay: flex;\n\t\tborder: solid 1px rgba(0, 0, 0, 0.2);\n\t\tborder-left: none;\n\t\tborder-right: none;\n\t\tpadding: 15px 0;\n\t}\n\n\t.footer-dl ul {\n\t\tdisplay: flex;\n\t\tflex-wrap: wrap;\n\t\tmargin: 5px 0;\n\t\tpadding: 0;\n\t\tlist-style: none;\n\t}\n\n\t.footer-dl ul li {\n\t\tfont-size: 12px;\n\t\tcolor: #b3b3b3;\n\t\tline-height: 16px;\n\t}\n\n\t.footer-dl ul li:first-child {\n\t\tfont-weight: 700;\n\t\tpadding-right: 10px;\n\t}\n\n\t.footer-dl ul li a {\n\t\tcolor: #b3b3b3;\n\t\tpadding: 0px 3px 0 0;\n\t}\n"])));

function FooterDirectLinks(_ref) {
  var data = _ref.data,
      adobe = _ref.adobe;

  var sendEvent = function sendEvent(dl) {
    adobe == null ? void 0 : adobe.track('ctaClick', {
      cta: {
        name: dl.text,
        destination: dl.url,
        componentName: 'footer',
        type: 'link'
      }
    });
  };

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style$1, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-dl"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, data.map(function (item) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("ul", {
      key: item.title
    }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", null, item.title), item.links && item.links.map(function (dl, index, arr) {
      return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("li", {
        key: dl.text
      }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("a", {
        href: dl.url,
        onClick: function onClick() {
          return sendEvent(dl);
        }
      }, dl.text, " ", arr.length - 1 === index ? '' : ' |'));
    }));
  }))));
}

var _templateObject;
var Style = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div */ .ZP.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n\t.happy-gi-footer {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tbackground: #fff;\n\t\tcolor: #000;\n\t\tfont-size: 16px;\n\t\tfont-family: 'QuickSand,Helvetica,Arial,sans-serif', sans-serif;\n\t\tfont-weight: 400;\n\t}\n\n\t.happy-gi-footer .footer-container {\n\t\twidth: 1100px;\n\t\tmargin: 0 auto;\n\t}\n\n\t.footer-sprite {\n\t\tbackground: url(https://gos3.ibcdn.com/footer-sprite-1688459091.png) no-repeat;\n\t\tbackground-size: 300px 200px;\n\t\tdisplay: -webkit-inline-flex;\n\t\tdisplay: -ms-inline-flexbox;\n\t\tdisplay: inline-flex;\n\t\t-webkit-flex-shrink: 0;\n\t\tflex-shrink: 0;\n\t}\n"])));

function Footer(_ref) {
  var data = _ref.data,
      adobe = _ref.adobe;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Style, null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("footer", {
    className: "happy-gi-footer"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "footer-container"
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterLinks, {
    adobe: adobe
  }), data && data.length > 0 && /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterDirectLinks, {
    data: data,
    adobe: adobe
  }), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(FooterAppLinks, null))));
}




/***/ })

}]);